<template>
  <div class="forget-pwd">
    <div class="main">
      <login-header></login-header>
      <div class="main-center">
        <div class="main-center-w w">
          <div>
            <div style="background-color: #f2f2f2">
              <p>重置密码</p>
            </div>
            <div class="form-div">
              <Form
                label-position="left"
                ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="110"
              >
                <FormItem label="手机号码：" prop="phone">
                  <input type="password"  class="hide"  name="password" autocomplete="off" />
                  <Input
                    v-model="formValidate.phone"
                    placeholder="请输入您的手机号"
                  ></Input>
                </FormItem>
                <FormItem label="验证码：" prop="code" class="pass-input">
                  <Input
                    
                    autocomplete="off"
                    v-model="formValidate.code"
                    placeholder="请输入验证码"
                    style="width: 70%"
                  >
                  </Input>
                  <Button
                    style="padding: 0 8px; margin: 4px; width: 110px"
                    type="primary"
                    @click="getCode('formValidate')"
                    :disabled="disabled"
                    >{{ btnText }}</Button
                  >
                </FormItem>
                <FormItem label="新密码：" prop="passwd">
                  <Input
                    autoComplete="new-password"
                    type="password"
                    v-model="formValidate.passwd"
                    placeholder="请输入您的新密码"
                  ></Input>
                  <span style="font-size: 12px; color: #c2c2c2"
                    >至少输入8位，支持字母、数字、标点符号。字母区分大小写</span
                  >
                </FormItem>
                <FormItem label="确认密码：" prop="password">
                  <Input
                    autoComplete="new-password"
                    type="password"
                    v-model="formValidate.password"
                    placeholder="请再次输入您的密码"
                  ></Input>
                </FormItem>
              </Form>
              <div class="subBtn">
                <Button type="primary" @click="handleSubmit('formValidate')" :disabled="isdisabled"
                  >提交</Button
                >
              </div>
            </div>
            <Login-Footer></Login-Footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginFooter from './components/login-footer.vue'
import LoginHeader from './components/login-header.vue'
import { passwd, getCodeSMS } from '../../../api/user'
export default {
  name: 'forget-pwd',
  components: { LoginFooter, LoginHeader },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请您重新输入您的密码'))
      } else if (value !== this.formValidate.passwd) {
        callback(new Error('确认密码与登录密码不一样'))
      } else {
        callback()
      }
    }
    return {
      formValidate: {
        phone: '',
        code: '',
        passwd: '',
        password: '',
        deviceId: ''
        // platformcode: 'JP-WSS'
      },
      isdisabled:true,
      disabled: false, // 控制按钮是否可以点击（false:可以点击，true:不可点击）
      totalCount: 0,
      ruleValidate: {
        phone: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ],
        passwd: [
          {
            required: true,
            message: '登录密码不能为空',
            trigger: 'blur'
          },
          {
            type: 'string',
            min: 8,
            message: '长度必须8位及以上',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassCheck,
            trigger: 'blur'
          }
        ]
      },
      contentShow: true
    }
  },
  created() {},
  methods: {
    // 获取短信验证码
    getCode(formValidate) {
      this.$refs[formValidate].validateField('phone', async (mobileError) => {
        if (mobileError) {
          this.$Message.warning('必须是手机号')
        } else {
          // 按钮60秒倒计时
          this.disabled = true
          this.totalCount = 60
          this.interval = setInterval(() => {
            this.totalCount--
            if (this.totalCount === 0) {
              clearInterval(this.interval)
              this.disabled = false
            }
          }, 1000)
          const res = await getCodeSMS({
            phone: this.formValidate.phone,
            platformCode: 'JP-WSS',
            type: 1
          })
          if (res.code == 0) {
            console.log(res)
            this.formValidate.deviceId = res.data
            this.isdisabled = false
          }
          // console.log(res)
        }
      })
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          console.log(this.formValidate)
          const res = await passwd(this.formValidate)
          console.log(res)
          if (res.status) {
            this.$Message.destroy()
            this.$Message.success({
              content: '修改成功，5秒后进入登录页面...',
              duration: 20
            })
            let n = 5
            let inval = setInterval(() => {
              if (n === 0) {
                this.contentShow = false
                clearInterval(inval)
                this.$Message.destroy()
                this.$router.push('/login')
              } else {
                n--
              }
            }, 500)
          }
        } else {
          this.$Message.error('验证失败')
        }
      })
    }
  },
  computed: {
    btnText() {
      return this.totalCount !== 0
        ? `${this.totalCount}秒再次获取`
        : '获取验证码'
    }
  },
  watch: {}
}
</script>
<style lang='less' scoped>
.forget-pwd {
  width: 100%;
  // height: 100%;
  background-color: #f2f2f2;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main {
    .main-center {
      .main-center-w {
        background-color: #ffffff;
        p {
          color: #505050;
          font-size: 22px;
          font-weight: bold;
          padding: 32px 0 15px 0;
          // border-bottom: 1px solid #e2e2e2;
        }
        .form-div {
          //  background-color: #ffffff;
          padding-top: 73px;
          width: 517px;
          height: 196px;
          // margin: 0 auto;
          margin-left: 310px;
          padding-bottom: 380px;
          /deep/ .ivu-form {
            margin-top: 7px;
            // border-top: 1px solid #e2e2e2;
            // border-left: 1px solid #e2e2e2;
            // border-right: 1px solid #e2e2e2;
            .ivu-form-item {
              padding: 7px 7px 7px 0;
              // border-bottom: 1px solid #e2e2e2;
              margin-bottom: 0;
              .ivu-form-item-label {
                font-size: 16px;
                font-weight: bold;
              }
              .ivu-input {
                border-radius: 0;
              }
              .ivu-form-item-content {
                .ivu-form-item-error-tip {
                  top: 5px;
                  left: 40%;
                }
              }
            }
            .pass-input {
              .ivu-form-item-content {
                border: 1px solid #ccc;
                .ivu-input {
                  border: none;
                }
                .ivu-btn span {
                  // cursor: pointer;
                  font-size: 12px;
                }
              }
            }
          }
          .subBtn {
            width: 400px;
            // margin: 0 auto;
            margin-left: 111px;
            margin-top: 80px;
            /deep/ .ivu-btn {
              font-size: 20px;
              width: 100%;
              span {
                // span {
                width: 100%;
                height: 100%;
                font-size: 20px;

                // }
              }
            }
          }
        }
      }
    }
  }
  .hide{
  width: 0;
  height: 0;
  border: none;
  position: absolute

}
}
</style>